import createSelectors from './createSelectors';
import Role from '../models/Role';

const Select = createSelectors(Role, {});

export default Select;
